import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import axios from 'axios'

const state = {
  shippingCompany: {},

  shippingCompanies: {
    data: [],
    count: 0,
    limit: 50,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  type: 'add',
  loading: false,
  dialog: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.shippingCompany = {
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, shippingCompany) => {
    state.shippingCompany = { ...shippingCompany }
    state.type = 'edit'
  },

  save: ({ state }, shippingCompany) => {
    const id = shippingCompany.id
    const method = id ? 'put' : 'post'

    state.loading = true
    return axios[method](`${process.env.VUE_APP_API_URL}/shippingCompany/${id || ''}`, shippingCompany)
      .then(_ => {
        store.dispatch('shippingCompanyStore/get')
        showSuccess('Transportadora salva com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/shippingCompany?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.shippingCompanies = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/shippingCompany/${id}`).catch(showError),

  getByCnpj: async ({ state }, cnpj) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/shippingCompany?${getQueryFromFilter({ cnpj })}`)
      .then(res => res.data)
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/shippingCompany/${id}`)
      .then(_ => {
        store.dispatch('shippingCompanyStore/get')
        showSuccess('Transportadora excluída com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
